import { Facebook, Instagram, KeyboardArrowRight, LinkedIn, LocalPhone, Mail, Twitter } from '@mui/icons-material';
import React from 'react';
import { Link } from 'react-router-dom';
import { EmailAddress, InstaURL, LInkdinURL, PhoneNumber } from '../../Config';

const ContentUs = () => {

    const socialMediaLinks = [
        {
            name: "Twitter",
            icon: <Twitter fontSize="large" />,
            description: "Get the latest news, updates and announcements.",
            link: "https://x.com/garrysahota700",
            cta: "Follow us on Twitter",
        },
        {
            name: "Instagram",
            icon: <Instagram fontSize="large" />,
            description: "Stay connected with us for behind-the-scenes content.",
            link: InstaURL,
            cta: "Follow us on Instagram",
        },
        {
            name: "Facebook",
            icon: <Facebook fontSize="large" />,
            description: "Join our community and stay engaged.",
            link: "https://www.facebook.com/GarrySahotaOfficial/",
            cta: "Follow us on Facebook",
        },
        {
            name: "LinkedIn",
            icon: <LinkedIn fontSize="large" />,
            description: "Connect with us for professional updates.",
            link: LInkdinURL,
            cta: "Follow us on LinkedIn",
        },
    ];

    return (
        <>
            <div className='__contactus' id='contactUs'>
                <div className='content-center'>
                    <div className='__sc-head'>
                        <h2>  Stay Connected With Us</h2>
                        <p> Feel free to reach out to discuss your project or inquire further about my services. I'm here to help and excited about the possibility of collaborating with you. Stay updated with the latest news, updates, and announcements by following us on our social media platforms.</p>
                    </div>

                    <div className='__sc-body'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='__card-info'>
                                    <div className='__icon'>
                                        <div className='__icon-in'>
                                            <Mail />
                                        </div>
                                    </div>

                                    <div className='__dis'>
                                        <p>Email</p>
                                        <h5>
                                            <Link target='_blank' to={`mailto:${EmailAddress}`}> {EmailAddress} </Link>
                                        </h5>

                                    </div>

                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='__card-info ---card-second-child'>
                                    <div className='__icon'>
                                        <div className='__icon-in'>
                                            <LocalPhone />
                                        </div>
                                    </div>

                                    <div className='__dis'>
                                        <p>Phone</p>
                                        <h5>
                                            <Link target='_blank' to={`https://wa.me/${PhoneNumber}`} rel="noopener noreferrer">
                                                +91 {PhoneNumber}
                                            </Link>
                                        </h5>
                                    </div>

                                </div>
                            </div>
                            {socialMediaLinks.map((social, index) => (
                                <div key={index} className="col-md-3">
                                    <div className="__card-com">
                                        <div className="__icon">
                                            <div className="__icon-in">
                                                {social.icon}
                                            </div>
                                        </div>


                                        <div className="__dis">
                                            <h5>{social.name}</h5>
                                            <p>{social.description}</p>
                                        </div>

                                        <Link target='_blank' to={social.link} className="__link stretched-link">
                                            {social.cta} <KeyboardArrowRight />
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default ContentUs;
